import React from "react";

export default function Header() {
  return (
    <div className="flex justify-between items-center">
      <img src="../assets/images/logo.png" alt="Logo" />
      <div className="flex flex-col lg:flex-row justify-center items-center gap-6">
        <a
          href="https://danalend.com/"
          className="text-xs hover:text-primary"
        >
          <span className="border-b hover:border-b-primary ">
            بازگشت به دانالند
          </span>
        </a>
        <a
          href="https://panel.danalend.com/"
          className="border border-borderColor rounded-md px-4 py-2 hover:bg-primary hover:text-background transition-all duration-500"
        >
          ورود به حساب کاربری
        </a>
      </div>
    </div>
  );
}
